<template>
  <div class="preloader">
      <div class="preloader-body">
        <div class="cssload-container">
          <div class="cssload-speeding-wheel"></div>
        </div>
        <p v-if="text1">{{ text1 }}...</p>
        <p v-else>Loading...</p>
      </div>
    </div>
</template>

<script>
export default {
  data(){
    return{
      seatmap:"",
      confirm:"",
      text1:""
    }
  },
  mounted(){
    let router = this.$route;
    console.log(this.$router,router,'router')
    if(router.path == "/seatmap"){
      this.text1 = "We're searching for the best available seats for you. Please wait while we load the seat selection."
    }
    else if(router.path == "/confirmBook"){
      this.text1 = "Please wait while we confirm your price. This may take a few minutes."
    }
  }
}
</script>

<style>
@import "@/assets/style.css";

</style>